<template>
    <div style="background: #fcfcfc; padding-bottom: 40px">
        <ais-instant-search :search-client="searchClient" index-name="nome" :routing="routing">
            <div class="wrapper flex">
                <div class="c" style="flex: 0 0 200px">
                     <ais-voice-search>
                        <template slot-scope="{ isBrowserSupported, isListening, toggleListening, voiceListeningState }">
                        <button class="button-voice" @click="toggleListening" v-if="isBrowserSupported" :class="{'active': isListening }">
                            <template v-if="isListening"><i class="ico-mic"></i> Estou te ouvindo</template>
                            <template v-else><i class="ico-mic_none"></i> Clique para falar</template>
                        </button>
                        <div class="speak" v-if="openDialog(voiceListeningState.status) && voiceListeningState.transcript">
                            {{ voiceListeningState.transcript }}
                        </div>
                    </template>
                </ais-voice-search>
                <ais-search-box  placeholder="Buscar...">
                        <div slot="reset-icon"><i class="ico-cancel"></i></div>
                </ais-search-box>
                <h3>Categorias</h3>
                <ais-refinement-list attribute="category.name">
                    <span slot="noResults" slot-scope="{ query }">Nenhum resultado encontrado.
                        <q>{{ query }}</q>
                    </span>
                </ais-refinement-list>

                <h3>Aplicação</h3>
                <ais-hierarchical-menu
  :attributes="[
    'industry.lvl0',
    'industry.lvl1',
    'industry.lvl2',
    'industry.lvl3',
  ]"
/>

                <h3>Opcionais</h3>
                <!-- <ais-toggle-refinement attribute="attributes.auto" label="Automática" /> -->
                <ais-refinement-list attribute="attributes" />
                <ais-clear-refinements :class-names="{'ais-ClearRefinements': 'MyCustomClearRefinements', 'ais-ClearRefinements-button': 'white'}">
                    <span slot="resetLabel">Limpar filtros</span>
                </ais-clear-refinements>
                </div>
                <div style="display: flex; flex-direction: column">
                    <div style="justify-content: flex-end; flex-flow: row; display: flex; align-content: center; align-items: center">
                        <ais-hits-per-page :items="paginationAttributes" />
                        <span style="display: block; padding: 10px 5px 0 15px; font-size: .75em"> Ordernar por:</span>
                        <ais-sort-by :items="sorterAttributes" />
                    </div>
                    <div class="grid">
                        <ais-state-results>
                            <template slot-scope="{ hits }">
                                <ais-hits v-if="hits.length > 0">
                                    <router-link :to="{path: '/maquina/'+item.uri}" class="card" slot="item" slot-scope="{ item }">
                                        <img v-if="item.files.images.length > 0" :src="item.files.images[0].url">
                                        <img v-else src="https://via.placeholder.com/800x600/ffffff/808080?text=Sem imagem">
                                        <div class="card-description">
                                            <h2>{{ item.shortName }}</h2>
                                            <h4>{{ item.category.name }}</h4>
                                        </div>
                                    </router-link>
                                </ais-hits>
                                <div v-else style="text-align: center; padding: 40px; background: #fff;  margin: 10px 0 10px 55px;">
                                    <h2>Nenhum resultado encontrado</h2>
                                    <p>Revise os filtros e tente novamente</p>
                                </div>
                            </template>
                        </ais-state-results>
                    </div>
                    <div style="display: flex; justify-content: space-between">
                        <ais-pagination :padding="2" />
                            <div style="flex: 1 1 100%;  justify-content: flex-end; display: flex; align-items: center; font-size: .75em;">
                            <ais-stats>
                                <p slot-scope="{ nbHits,processingTimeMS }">
                                    <strong> {{ nbHits }}</strong> Máquinas encontradas em <strong>{{ processingTimeMS }}ms</strong>
                                </p>
                            </ais-stats>
                            <ais-powered-by theme="string" :class-names="object" />
                        </div>
                    </div>
                </div>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import { simple } from 'instantsearch.js/es/lib/stateMappings';


// import 'instantsearch.css/themes/algolia-min.css'
export default {
    name: "Machines",
    data() {
        return {
            paginationAttributes: [
                { label: '6 por página', value: 6 },
                { label: '12 por página', value: 12, default: true },
                { label: '24 por página', value: 24 }, 
            ],
            sorterAttributes: [
                { value: 'nome', label: 'Destaques' },
                { value: 'nome', label: 'Nome (a-z)' },
                { value: 'nome_', label: 'Nome (z-a)' },
                { value: 'categoria', label: 'Categoria (a-z)' },
                { value: 'categoria_', label: 'Categoria (z-a)' },
            ],
            routing: {
                stateMapping: simple()
            },
            searchClient: algoliasearch(
                'KP3JUPUVTS',
                '17482ab5934580dbae89e562b2ff5f18'
            )
        };
  },
  methods: {
      openDialog(status){
          if(status == 'finished'){
              setTimeout(() => {
                  return false
              },3000)
          }
          else{
              return true
          }
      }
  }
}
</script> 
<style lang="scss"  scoped>
    .button-voice{
        width: 100%;
        margin: 10px 0 5px;
        &.active{
            animation: pulse-black 2s infinite;
        }
    }
    .speak{
        background: #dbe3e4;
        position: absolute;
        padding: 5px 8px;
        border-radius: 3px;
        margin: 3px;
        box-shadow: 0 1px 11px rgba(0,0,0,.15);
        z-index: 9;
    }
    @keyframes pulse-black {
	0% {
		// transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(50,73,155, 0.7);
	}
	30% {
		// transform: scale(1);
		box-shadow: 0 0 0 5px rgba(50,73,155, 0);
	}
	
	70% {
		// transform: scale(1);
		box-shadow: 0 0 15px 15px rgba(50,73,155, 0);
	}
	
	100% {
		// transform: scale(0.95);
		box-shadow: 0 0 15px 0 rgba(50,73,155, 0);
	}
}

</style>